/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
//@import BaseMoserObject (loadtime) // superclass

/**
 * This object represents the module validation results. It is built in a hierarchical way so that a <code>Diagnostic</code> can have a list of <code>Diagnostic</code>s as it children recursively.
 */
export default class Diagnostic extends BaseMoserObject{

	static OK = 0x0;

	static INFO = 0x1;

	static WARNING = 0x2;

	static ERROR = 0x4;

	severity = 0;

	label = null;

	featureID = 0;

	object = null;

	validationMessage = null;



	static _getSeverityCode(severity) {
		if ("ok" == severity) {
			return 0;
		} else if ("error" == severity) {
			return 4;
		} else if ("warning" == severity) {
			return 2;
		} else if ("info" == severity) {
			return 1;
		}
		return 0;
	}

	/**
	 * Retrieve the severity of this validation result
	 * @return {int}  a  {@link Integer}  value of the severity
	 */
	getSeverity() {
		return this.severity;
	}

	/**
	 * Set the <code>ValidationMessage</code>.
	 * @param {ValidationMessage} message   {@link ValidationMessage}
	 */
	setValidationMessage(message) {
		this.validationMessage = message;
		var msgSeverity = Diagnostic._getSeverityCode(message.getSeverity());
		if (this.severity < msgSeverity) {
			this.severity = msgSeverity;
		}
	}

	/**
	 * Get the <code>ValidationMessage</code>.
	 * @return {ValidationMessage}  the list of messages
	 */
	getValidationMessages() {
		return this.validationMessage;
	}

	/**
	 * Set the value reference of the validation message
	 * @param  data   {@link String}
	 */
	setLabel(label) {
		this.label = label;
	}

	/**
	 * Retrieve the value reference of the validation message
	 * @return {String}
	 */
	getLabel() {
		return this.label;
	}

	/**
	 * Set the featureID linked with the related <code>MoserObject</code>
	 * @param {int} featureID
	 */
	setFeatureID(featureID) {
		this.featureID = featureID;
	}

	/**
	 * Get the featureID linked with the related <code>MoserObject</code>
	 * @return {int}   {@link  int}  featureID of the <code>MoserObject</code>
	 */
	getFeatureID() {
		return this.featureID;
	}

	/**
	 * Get the related moser object that associated with thie error
	 * @return {MoserObject}   {@link Object}  <code>MoserObject</code>
	 */
	getObject() {
		return this.object;
	}

	/**
	 * Set the related moser object to this validation result
	 * @param {MoserObject} obj
	 */
	setObject(obj) {
		this.object = obj;
	}

	/**
	 * Set the properties of this <code>Diagnostic</code>
	 * @param  obj
	 * @param {String} data
	 * @param {ValidationMessage} message
	 * @param {int} featureId
	 */
	setProperties(object, data, message, featureId) {
		this.setValidationMessage(message);
		this.setLabel(data);
		this.setFeatureID(featureId);
		this.setObject(object);
	}
}


// WEBPACK FOOTER //
// ./src/generated/Diagnostic.js